import { useAsyncOperationWithData } from '../../utilities/accounting/hooks/useAsyncOperationWithData';
import { getEscrowFileByOrderIdAsync } from '../../API/accounting/getEscrowFileByOrderIdAsync';
import { useDoActionOnceBasedOnFetchStatus } from '../../utilities/accounting/hooks/useDoActionOnceBasedOnFetchStatus';
import { useEffect } from 'react';

/**
 * Get the Escrow File associated to an Order Id
 * FYI: This async function will create any missing escrow files because we don't create them at Order Creation in API
 * @param orderId
 */
export const useEscrowFileByOrderId = (orderId?: string) => {
  const [{ fetchStatus, fetchError, data }, loadEscrowFile, resetEscrowFile] =
    useAsyncOperationWithData(getEscrowFileByOrderIdAsync);

  // Reset and try to load whenever the orderId changes
  useEffect(() => {
    resetEscrowFile();
  }, [orderId, resetEscrowFile]);

  // If there is an order Id, then load it. ONLY if we haven't loaded it yet.
  useDoActionOnceBasedOnFetchStatus(() => {
    if (orderId) {
      loadEscrowFile(orderId);
    }
  }, fetchStatus);

  return {
    fetchStatus,
    fetchError: fetchStatus.fetched ? fetchError : !fetchStatus.fetching ? fetchError : undefined,
    data,
  };
};
